import React, { useState } from "react";
import {
  Container,
  Form,
  FormButton,
  FormContent,
  FormH1,
  FormInput,
  FormTextArea,
  FormWrap,
  FormLabel,
  Icon,
} from "./QuoteElements";
import nodemailer from "nodemailer";
import axios from "axios";

import LogoNim from "../../images/logo-nim.png";
import { Logo } from "../Navbar/NavbarElements";

const Quote = () => {
  const [contact, setContact] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "NIM Agency - Contact Request",
    honeypot: "", // if any value received in this field, form submission will be ignored.
    message: "",
    replyTo: "agencynim@gmail.com", // this will set replyTo of email to email address entered in the form
    accessKey: "493274d5-c609-4734-a53e-451f873da6eb", // get your access key from https://www.staticforms.xyz
  });
  const [response, setResponse] = useState({
    type: "",
    message: "",
  });

  const handleChange = (e) => {
    setContact({ ...contact, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch("https://api.staticforms.xyz/submit", {
        method: "POST",
        body: JSON.stringify(contact),
        headers: { "Content-Type": "application/json" },
      });

      const json = await res.json();

      if (json.success) {
        setResponse({
          type: "success",
          message: "Thank you for reaching out to us.",
        });
      } else {
        setResponse({
          type: "error",
          message: json.message,
        });
      }
    } catch (e) {
      console.log("An error occurred", e);
      setResponse({
        type: "error",
        message: "An error occured while submitting the form",
      });
    }
  };

  const resetForm = () => {
    document.getElementById("contact-form").reset();
  };

  return (
    <>
      <Container>
        <FormWrap>
          <Icon to="/">
            <Logo src={LogoNim} />
          </Icon>
          <FormContent>
            <Form
              id="contact-form"
              onSubmit={handleSubmit}
              action="https://api.staticforms.xyz/submit"
              method="post"
            >
              <FormH1>
                Lets Work see how can we collaboration. Tells us more about your
                needs.
              </FormH1>

              <FormLabel htmlFor="for">Full Name</FormLabel>
              <FormInput
                name="name"
                value={contact.name}
                onChange={handleChange}
                type="text"
                required
              />
              <FormLabel htmlFor="for">Email</FormLabel>
              <FormInput
                name="email"
                value={contact.email}
                onChange={handleChange}
                type="email"
                required
              />
              <FormLabel htmlFor="for">Phone number</FormLabel>
              <FormInput
                name="phone"
                value={contact.phone}
                onChange={handleChange}
                type="numeric"
              />
              <FormLabel htmlFor="for">Message</FormLabel>
              <FormTextArea
                name="message"
                value={contact.message}
                onChange={handleChange}
                required
              />
              {response.type === "success" ? (
                <p
                  style={{
                    color: "lightgreen",
                    textAlign: "center",
                    marginBottom: "30px",
                  }}
                >
                  {response.message}
                </p>
              ) : (
                ""
              )}
              {response.type === "error" ? <p>{response.message}</p> : ""}
              <FormButton type="submit">Continue</FormButton>
            </Form>
          </FormContent>
        </FormWrap>
      </Container>
    </>
  );
};

export default Quote;
